import type { Theme } from '../../types/theme';

export const spotifyTheme: Theme = {
  id: 'spotify',
  name: 'Spotify',
  description: 'Near-black immersive dark theme with Spotify Green accent',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/spotify/DESIGN.md',
  visualKeywords: ['dark', 'immersive', 'green accent', 'pill buttons', 'audio-first'],
  colors: {
    background: '#121212',
    surface: '#181818',
    surfaceElevated: '#222222',
    textPrimary: '#ffffff',
    textSecondary: '#b3b3b3',
    textMuted: '#b3b3b3',
    border: '#404040',
    borderSubtle: '#4a4a4a',
    primary: '#1ed760',
    primaryHover: '#2de66f',
    primaryActive: '#00b942',
    accent: '#1ed760',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'immersive',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
